/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleUpDown: {
  name: 'triangle-up-down';
  data: string;
} = {
  name: 'triangle-up-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5H5l3-4 3 4Zm0 6H5l3 4 3-4Z" fill="currentColor"/></svg>`,
};
